<template>
  <el-dialog title="微课分享" :visible.sync="dialogVisible" width="40%" top="150px">
    <!-- <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">选择分享</el-checkbox> -->
    <div style="margin: 15px 0;"></div>
    <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
      <el-checkbox v-for="city in cities" :label="city.class_id" :key="city.class_id">{{ city.class_name }}</el-checkbox>
    </el-checkbox-group>
    <div v-if="this.cities.length == 0" style="text-align: center;">无分享班级</div>
    <div style="width:100%;text-align:center" v-if="!this.cities.length == 0">
      <el-button @click="fff" style="margin-top:40px;text-align:center" type="primary" size="small">分享</el-button>
    </div>
  </el-dialog>
</template>

<script>
let cityOptions = []
import { mapState } from 'vuex'
export default {
  props: ['boardId', 'shareid'],
  data () {
    return {
      dialogVisible: false,
      checkAll: false,
      checkedCities: [],
      cities: [],
      isIndeterminate: true,
      classid: [],
      valueid: []

    }
  },
  computed: {
    ...mapState({
      classInfo: state => state.classInfo
    })
  },
  watch: {
    boardId (newName, oldName) {
      this.boardId = newName
    },
    "classInfo.id" (val) {
      this.checkedCities = []
      this.classid = []
      this.cutClassData()
    }
  },
  mounted () {
    this.cutClassData()
  },
  methods: {
    async fff () {
      // let newarr = []
      // for (let i = 0; i < this.cities.length; i++) {
      //   for (let j = 0; j < this.cities.length; j++) {
      //     if (this.cities[i].class_id == this.classid[j]) {
      //       newarr.unshift(this.cities[i].course_id)
      //     }
      //   }
      // }
      // 获取要分享的课程id
      let courseId = []
      for (const classId of this.checkedCities) {
        this.cities.forEach(item => {
          if (classId === item.class_id) {
            courseId.push(item.course_id)
          }
        })
      }
      const res = await this.$axios.post('/base/file/share', {
        class_ids: this.classid.join(),
        course_ids: courseId.join(),
        file_id: this.shareid
      })
      if (res.status == 200 && res.data.errCode == 0) {
        this.$message.success('分享成功！')
        this.checkedCities = []
        this.dialogVisible = false
      } else {
        this.$message.error(res.data.message)
      }
    },
    async cutClassData () {
      const res = await this.$axios.post('/base/user/classes', {
        class_id: this.classInfo.id,
        course_id: this.classInfo.course_id
      })
      if (res.status == 200 && res.data.errCode == 0) {
        this.cities = res.data.data
        // console.log(this.cities.length)
      } else {
        this.$message.error(res.data.message)
      }
    },
    handleCheckAllChange (val) {
      this.checkedCities = val ? cityOptions : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange (value) {
      this.classid = value
      let checkedCount = value.length
      this.checkAll = checkedCount === this.cities.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length
    }
  },
}
</script>

<style lang="scss" scoped>
.page-img {
  width: 100%;
  // height: 100%;
  height: 540px;
}

/deep/ .el-checkbox-group {
  position: relative;
  right: 0;
  top: 15px !important;
}

/deep/ .el-checkbox__input {
  position: relative;
}

/deep/ .el-checkbox__inner::before {
  top: 10px;
  left: 0;
}

/deep/ .el-checkbox {
  margin-bottom: 25px;
}

/deep/ .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
  top: 10px;
}

/deep/ .el-dialog__body {
  padding: 30px;

}
</style>



// WEBPACK FOOTER //
// src/view/Panel/kejian/share.vue